// Having an AMD require in the bundle makes sure the universalTypeahead module is loaded
// Since the universalTypeahead AMD module requires UITK, this will load after UITK is loaded.
var utaScriptLoadingStartedTimestamp = Date.now();
require('universalTypeahead', function (uTA) {
    window.utaModuleReadyTimeStamp = Date.now();
    // What is this thing doing?
    // After this file is loaded and once jQuery fires the document ready notification...
    // Then we look for any elements with attribute 'data-provide="utypeahead"' and if we
    // find any then we attach a focus handler using uTA.
    // This works in a similar manner to uitk-typeahead
    // (See http://uitoolkit.sb.karmalab.net/uitoolkit-current/docs/components/interactive/type-ahead)
    //
    //      data-provide="utypeahead"
    //      data-template="#uitk-ta-default || #uitk-ta-by-category"
    //      data-js-theme="typeahead || typeahead-by-category"
    //
    $(function autoAttachUniversalTypeahead() {

        var attachedInputIdCache = [];
        var dataProvideAttr = '[data-provide=utypeahead]';

        // If an element has the attribute 'data-provide={typeahead provider string}' then we
        // use that to attach a typeahead instance to it if there is also a 'data-template="<uitk template name>"'
        // and a 'data-js-theme="<uitk js theme name>"'
        $('body').on('focus.typeahead input.typeahead', dataProvideAttr, function () {
            var $el = $(this),
                inputId,
                template, // UITK required attribute
                jsTheme, // UITK required attribute
                options;

            // If this element already has a typeahead instance associated with it,
            // then there's nothing to do here so we just move along.
            if ($el.data('typeahead')) {
                return;
            }

            inputId = '#' + $el.attr('id');

            if(attachedInputIdCache.indexOf(inputId) > -1) {
                return;
            }
            attachedInputIdCache.push(inputId);

            template = $el.data('template');
            jsTheme = $el.data('jsTheme');
            options = $el.data();

            // UITK documentation states that data-template and data-js-theme are required in combination with data-provide="typeahead"
            // in order for a typeahead instance to be attached to an element. If that's not the case, notify the developers.
            if (!(_.isString(template) && _.isString(jsTheme))) {
                console && console.trace && console.trace(
                    "The data-template and data-js-theme attributes are required " +
                    "in combination with data-provide in order to attach a typeahead instance to an element. (according to UITK documentation) " +
                    "See: http://uitoolkit.sb.karmalab.net/uitoolkit-current/docs/components/interactive/type-ahead"
                );
            }

            // OK, all criteria seem to be met,
            // create a new uTA and associate with this element
            uTA.initTA(inputId, template, options);
        });

        uTA.handlePageLoad();
    });
});

